import AOS from 'aos';
// import { Fancybox } from '@fancyapps/ui';
// import '@fancyapps/ui/dist/fancybox/fancybox.css';
// import Swiper, { Navigation, EffectFade } from 'swiper';
// import 'slick-carousel';
// import '@fancyapps/fancybox';
// import '@lottiefiles/lottie-player';

export default {
  init() {
    jQuery('body').addClass('loading');

    window.onscroll = header;
    function header() {
      if(document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
        document.querySelector('header.banner').classList.add('scrolled');
      }
      else {
        document.querySelector('header.banner').classList.remove('scrolled');
      }
    }

    jQuery(document).ready(function($){
      AOS.init();

      setTimeout(function(){
        AOS.refresh();
        $('body').removeClass('loading');
      }, 700);
    });
  },
  finalize() {
    $('.hamburger').on('click', function(){
      $(this).toggleClass('is-active');
      $('.nav-primary').toggleClass('open');
      $('body').toggleClass('no-scroll');
    });

    /*
     * Countdown
    */

    if($('.flipdown').length) {
      var theCountdown = new Date( $('.flipdown').data('datetime') );
      var countdownTimestamp = Math.floor(theCountdown.getTime() / 1000);

      new FlipDown(countdownTimestamp, {
        headings: ['Tage', 'Stunden', 'Minuten', 'Sekunden'],
      }).start();
    }

    var readonlyField = document.querySelectorAll('.gf_readonly input');
    readonlyField.forEach(function(field){
      field.setAttribute('readonly', 'readonly');
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js